import styled from 'styled-components';

export const BlankCardStyled = styled.div`
  width: 100%;
  background: ${(props) => props.theme.color.white};
  border: 1px solid ${(props) => props.theme.color.lightGray};
  box-sizing: border-box;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
  overflow: hidden;
  align-items: center;
  justify-content: space-between;

  &.withShadow {
    width: 100%;

    .titleBar {
    }
  }

  .facility-title {
    font-size: 18px;
    font-weight: 700;
    margin-top: -22px;
    margin-left: 32px;
  }

  &.noTitleBar {
    .shipment-wrapper {
      position: relative;
      z-index: 1;
      background-color: ${(props) => props.theme.color.white} !important;
      padding: 24px !important;
    }
  }
  .img-wrapper{
    .share-tost {
      width: 40px;
      height: 40px;
      border-radius: 20px;
      background: ${(props) => props.theme.color.white};
      box-shadow: rgba(33, 57, 79, 0.08) 0px 3px 7px;
      top: 10px;
      right: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      margin-right: 22px;
  
      .filter {
        width: 18px;
        height: 20px;
        margin:0px;
  
        .ic {
          width: 20px;
          height: 20px;
          border: none;
          margin-top: 1px;
        }
  
        .filterBox {
          min-width: 198px;
          text-align: left;
          background: ${(props) => props?.theme?.color?.white};
          border: 1px solid ${(props) => props?.theme?.color?.borderLight};
          padding: 16px 14px;
          position: absolute;
          right: -18px;
          border-radius: 4px;
          margin-top: 6px;

          .openUp{
            top:0px !important;
            bottom:0px !important;
          }
  
          .box {
            margin: 0 0 16px 0;
            padding: 0px !important;
  
            .title {
              font-size: 15px;
              font-weight: 600;
              margin: 0px !important;
  
              .react-share__ShareButton {
                width: 100%;
                display: flex;
                flex-direction: row;
                align-items: center;
  
                > div {
                  width: 36px;
                  height: 36px;
                  margin-right: 10px !important;
                  position: relative;
                }
              }
            }
  
            &:last-child {
              margin: 0;
            }
          }
  
          &.openUp {
            top: auto;
            bottom: calc(100% + 20px);
  
            &::before {
              top: auto;
              bottom: -9px;
              transform: rotate(180deg);
            }
  
            &::after {
              top: auto;
              bottom: -8px;
              transform: rotate(180deg);
            }
          }
  
          &:before,
          &:after {
            content: '';
            width: 12px;
            height: 8px;
            position: absolute;
            border-top: 0;
          }
          &:after {
            top: -8px;
            right: 20px;
            border-bottom: 8px solid ${(props) => props.theme.color.white};
            border-right: 8px solid transparent;
            border-left: 8px solid transparent;
          }
          &:before {
            top: -10px;
            right: 19px;
            border-bottom: 9px solid ${(props) => props.theme.color.border};
            border-right: 9px solid transparent;
            border-left: 9px solid transparent;
          }
        }
      }
    } 
  }

  .img-wrapper {
    > div {
      margin-right: 5px !important;
    }

    &.min-80 {
      min-width: 80px;
      margin-right: 16px;
      display: flex;
      justify-content: flex-end;
    }
    &.guestFlowRecords{
      margin: 0px;
      margin-right: 11px;
    }
  }
  .cursor-pointer {
    cursor: pointer;
  }

  .titleBar {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;

    &.borderBottom {
      border-bottom: 1px solid ${(props) => props.theme.color.borderLight};
    }
  }

  .rightSide {
    margin: 24px;
  }

  .title {
    font-size: 18px;
    font-weight: 700;
    margin: 24px;
  }
 
  .share-tost {
    width: 40px;
    height: 40px;
    border-radius: 20px;
    background: ${(props) => props.theme.color.white};
    box-shadow: rgba(33, 57, 79, 0.08) 0px 3px 7px;
    top: 10px;
    right: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    margin-right: 22px;

    .filter {
      width: 18px;
      height: 20px;

      .ic {
        width: 18px;
        height: 20px;
      }

      .filterBox {
        min-width: 198px;
        text-align: left;
        background: ${(props) => props?.theme?.color?.white};
        border: 1px solid ${(props) => props?.theme?.color?.borderLight};
        padding: 16px 14px;
        position: absolute;
        right: 16px;
        border-radius: 4px;
        margin-top:20px;
        z-index: 999;

        .box {
          margin: 0 0 16px 0;
          padding: 0px !important;

          .title {
            font-size: 15px;
            font-weight: 600;
            margin: 0px !important;

            .react-share__ShareButton {
              width: 100%;
              display: flex;
              flex-direction: row;
              align-items: center;

              > div {
                width: 36px;
                height: 36px;
                margin-right: 10px !important;
                position: relative;
              }
            }
          }

          &:last-child {
            margin: 0;
          }
        }

        &.openUp {
          top: auto;
          bottom: calc(100% + 20px);

          &::before {
            top: auto;
            bottom: -9px;
            transform: rotate(180deg);
          }

          &::after {
            top: auto;
            bottom: -8px;
            transform: rotate(180deg);
          }
        }

        &:before,
        &:after {
          content: '';
          width: 12px;
          height: 8px;
          position: absolute;
          border-top: 0;
        }
        &:after {
          top: -8px;
          right: 20px;
          border-bottom: 8px solid ${(props) => props.theme.color.white};
          border-right: 8px solid transparent;
          border-left: 8px solid transparent;
        }
        &:before {
          top: -10px;
          right: 19px;
          border-bottom: 9px solid ${(props) => props.theme.color.border};
          border-right: 9px solid transparent;
          border-left: 9px solid transparent;
        }
      }
    }
  } 
  

  .arrow-icon {
    margin-right: 18px;
    width: 14px;
  }

  .dropdown-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    .dropdown {
      width: 210px;
      .dropdown-toggle {
        height: 40px;
        width: 210px;
        padding: 7px 35px 8px 15px;
        font-size: 14px;
        font-weight: 700;
      }
    }
    .showFilter {
      width: 40px;
      height: 40px;
      margin-left: auto;
      position: relative;
    }
  }
  .mergeShipmentWrapper {
    padding: 24px 0;
    margin-right: 24px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    .form-check {
      .form-check-input[type='checkbox'] {
        margin-top: 1px;
        margin-right: 16px;
      }
      .form-check-label {
        color: ${(props) => props.theme.text.dark};
        font-size: 16px;
        line-height: 20px;
        font-weight: 600;
      }
    }
    .deliveryTime {
      color: ${(props) => props.theme.text.medium};
      font-size: 14px;
      line-height: 18px;
      font-weight: 600;
      margin: 6px 0 0 36px;
    }

    .shipmentMergeDetail {
      display: flex;
      flex-direction: column;

      .top {
        color: ${(props) => props.theme.text.dark};
        font-size: 16px;
        line-height: 20px;
        font-weight: 600;
        margin: 0 0 8px 0;
      }
      .bottom {
        color: ${(props) => props.theme.text.medium};
        font-size: 14px;
        line-height: 18px;
        font-weight: 600;
      }
    }
  }

  > .label {
    font-weight: 600;
    font-size: 14px;
    color: ${(props) => props.theme.text.medium};
    min-width: 70px;
  }

  hr {
    background-color: ${(props) => props.theme.color.borderLight};
    // opacity: 1;
    margin: 0;
  }

  .box {
    width: 100%;
    padding: 24px;
    position: relative;
  }

  .divider {
    width: 100%;
    height: 1px;
    background: ${(props) => props.theme.color.lightGray};
  }
  .blue-text {
    color: ${(props) => props.theme.blue.dark};
    font-weight: 700;
    font-size: 16px;
    margin-right: 24px;
    cursor: pointer;
  }
  .sub-title {
    font-weight: normal;
    font-size: 14px;
    color: ${(props) => props.theme.text.light};
    margin: 5px 0 0 0;
  }
  .dropdown-label {
    font-weight: 600;
    font-size: 14px;
    color: ${(props) => props.theme.text.medium};
    min-width: 55px;
  }

  &.upload_docs {
    .img-wrapper {
      white-space: nowrap;
      width: 100%;
      justify-content: flex-end;
    }
  }
  .mobile_filter_btn {
    &.ic {
      width: 30px;
      height: 30px;
      background: ${(props) => props.theme.color.white};
      border: 1px solid ${(props) => props.theme.blue.dark};
      border-radius: 6px;
      display: none;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      box-shadow: -10px 0 0 ${(props) => props.theme.color.white};
      &.disabled {
        border: 1px solid ${(props) => props.theme.blue.grey};
      }
    }
  }
  @media (max-width: 767px) {
    .mobile_filter_btn {
      &.ic {
        display: inline-flex;
      }
    }
    .box {
      padding: 24px 16px;
    }
  }
  @media (max-width: 480px) {
    .title {
      font-size: 17px;
    }
  }
`;
